import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useCreateContractorUserDataMutation } from "store/services/contractorUserApi";
import ContractorUserForm from "./contractorComponents/ContractorUserForm";

const ContractorUserCreateScreen = () => {
  const [createContractorUser, { isLoading: creatingContractorUser }] =
    useCreateContractorUserDataMutation();
  const navigate = useNavigate();

  const breadcrumbs = [
    {
      title: "Contractor",
      path: "/app/crm/contractorUser/list",
    },
    { title: "New Contractor" },
  ];

  // Create Contractor User
  const handleCreateContractorUser = async (data) => {
    createContractorUser(data)
      .unwrap()
      .then(() => {
        navigate(breadcrumbs[0].path);
        toast.success("Contractor User created successfully");
      })
      .catch((error) => {
        const errorMessage = error?.data?.message || "Something went wrong!";
        toast.error(errorMessage);
      });
  };

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingContractorUser}>
      <BreadcrumbLayout.Paper>
        <ContractorUserForm
          isBusy={creatingContractorUser}
          onSubmit={handleCreateContractorUser}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default ContractorUserCreateScreen;
